import { ListItemButton, styled } from '@mui/material';
import theme from 'theme';

export const StyledListItemButton = styled(ListItemButton)(() => ({
  backgroundColor: theme.palette.primary.light,
  borderRadius: theme.spacing(1),
  marginBottom: theme.spacing(0.75),
  textTransform: 'uppercase',
  width: 'fit-content',

  '&:hover': {
    backgroundColor: theme.palette.primary.extraLight,
  },
}));
